/**
 * User Group Constants
 */

export const SUPER_ADMIN = 1;
